import { AuditMediaPlayerAction } from '@app/modules/audit/components/AuditMediaPlayerAction';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import { AuditMatch, toTimestamp } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { FormattedMessage } from 'react-intl';
import { RowActionMui } from '../../../../../../components/table/RowActionMui';
import { RowActions } from '../../../../../../components/table/RowActions';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { auditDownloadAudio } from '../../../../actions';
import { useAuditMatchColumns } from '../../../../hooks/useAuditMatchColumns';
import { AdsMatchesListing } from './types';

export const AdsMatchesList = (p: ReportResultProps<AdsMatchesListing>) => {
  const station = useActiveStation();

  const showOnStreamUrlFn = (match: AuditMatch) => {
    const from = toTimestamp(match.datetime);
    return buildLoggerStreamUrl(station.slug, {
      selection: { from, to: from + match.playedDuration },
      tab: 'audiomatches',
    });
  };

  const downloadAudio = (match: AuditMatch) => {
    auditDownloadAudio({
      stationId: station.id,
      customId: match.audio!.customId,
    });
  };

  const columns = useAuditMatchColumns({
    timeColumnType: 'datetime',
    actionsColumn: (row) => (
      <RowActions>
        <RowActionMui
          title={
            <FormattedMessage
              id="audit.matchesScreen.showOnStreamBtn"
              defaultMessage="Mostrar en stream"
            />
          }
          link={showOnStreamUrlFn(row.original)}
        >
          <OpenInNewIcon />
        </RowActionMui>
        <RowActionMui
          onClick={() => downloadAudio(row.original)}
          title={
            <FormattedMessage
              id="audit.matchesScreen.downloadBtn"
              defaultMessage="Descargar archivo"
            />
          }
        >
          <DownloadIcon />
        </RowActionMui>
        {row.original.audio && (
          <AuditMediaPlayerAction
            audio={{
              ...row.original.audio,
              stationId: station.id,
            }}
            ActionComponent={RowActionMui}
          />
        )}
      </RowActions>
    ),
  });

  return <MrtTable columns={columns} data={p.result.results} enableTopToolbar={false} />;
};
